/*  @flow */
import * as React from 'react';

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';
import type { Action } from 'components/ActionsList/ActionsList';

import { updateDisableEnableAccount } from 'permissions/account';

export const actionsListSingle: Action[] = [
  {
    label: 'general:actions.disable_trading_account',
    icon: '#icon-disable',
    class: 'disable',
    action: 'disableAccount',
    type: 'drawer',
    permissions: updateDisableEnableAccount,
    condition(accounts, action, callback) {
      const combinedStatus = accounts.map(account => account.status).includes('Active');
      return combinedStatus && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.enable_trading_account',
    icon: '#icon-approve',
    class: 'enable',
    action: 'enableAccount',
    type: 'drawer',
    permissions: updateDisableEnableAccount,
    condition(accounts, action, callback) {
      const combinedStatus = accounts.map(account => account.status).includes('Disabled');
      return combinedStatus && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
];

export const actionsListMultiple: Action[] = [
  {
    label: 'general:actions.disable_trading_account_plural',
    icon: '#icon-disable',
    class: 'disable',
    action: 'disableAccountMulti',
    type: 'drawer',
    permissions: updateDisableEnableAccount,
    condition(accounts, action, callback) {
      const combinedStatus = accounts.map(account => account.status).includes('Active');
      return combinedStatus && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.enable_trading_account_plural',
    icon: '#icon-approve',
    class: 'enable',
    action: 'enableAccountMulti',
    type: 'drawer',
    permissions: updateDisableEnableAccount,
    condition(accounts, action, callback) {
      const combinedStatus = accounts.map(account => account.status).includes('Disabled');
      return combinedStatus && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
];
